import React from 'react';
import { Modal } from '@/components';
import '@/assets/styles/components/student-rating-modal.styles.scss';
import type { StudentRatingModalProps } from './student-rating-modal.types';
import clsx from 'clsx';

const StudentRatingModal: React.FC<StudentRatingModalProps> = ({ isOpen, onClose, interactionFeedback }) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			closeOnEsc={true}
			closeOnClickOutside={true}
			size="md"
			className="feedback-modal"
			bodyClassName="feedback-modal-body">
			<div
				className="close-icon"
				onClick={onClose}>
				<i className="icons-close" />
			</div>

			<div className="feedback-content">
				<div className="feedback-header">
					<div className="student-info">
						<div className="student-avatar">
							<img
								src={interactionFeedback?.studentAvatarUrl}
								alt={interactionFeedback?.studentName}
							/>
						</div>
						<div className="student-details">
							<h3>{`${interactionFeedback?.studentName} ${interactionFeedback?.studentSurname?.[0]}.`}</h3>
							<span className="student-class">{interactionFeedback?.studentGradeName}</span>
						</div>
					</div>
					<div className="rating-display">
						{[1, 2, 3, 4, 5].map(star => (
							<i
								key={star}
								className={clsx(
									'icons-star-sharp',
									star <= (interactionFeedback?.rating || 0)
										? clsx('filled', {
												red: (interactionFeedback?.rating || 0) < 3,
												orange: interactionFeedback?.rating === 3
											})
										: ''
								)}
							/>
						))}
					</div>
				</div>
				<div className="feedback-tags">
					{interactionFeedback?.optionSelections?.map((tag, index) => (
						<div
							key={index}
							className="tag">
							{tag?.feedbackOption?.name}
						</div>
					))}
				</div>

				{interactionFeedback?.commentToExpert && <div className="feedback-text">{interactionFeedback?.commentToExpert}</div>}
			</div>
		</Modal>
	);
};

export default StudentRatingModal;
